import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const getGoogleAccount = createAsyncThunk('google/getAccount', async ({ accountId, domainId }) => {
  const response = await fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/google/account`);
  return await response.json();
});

export const getGoogleAnalyticsAccount = createAsyncThunk(
  'googleAnalytics/getAccount',
  async ({ accountId, domainId }) => {
    const response = await fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/googleAnalytics/account`);
    return await response.json();
  }
);

export const googleSlice = createSlice({
  name: 'google',
  initialState: {
    account: null,
    analyticsAccount: null,
    loading: null,
    error: null,
  },
  reducers: {
    setGoogleAccount: (state, action) => {
      state.account = action.payload;
    },
    setGoogleAnalyticsAccount: (state, action) => {
      state.analyticsAccount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGoogleAccount.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getGoogleAccount.fulfilled, (state, action) => {
        const account = action.payload.googleAccount;
        state.account = account;
        state.loading = false;
      })
      .addCase(getGoogleAccount.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      .addCase(getGoogleAnalyticsAccount.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getGoogleAnalyticsAccount.fulfilled, (state, action) => {
        const analyticsAccount = action.payload.googleAnalyticsAccount;
        state.analyticsAccount = analyticsAccount;
        state.loading = false;
      })
      .addCase(getGoogleAnalyticsAccount.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setGoogleAccount, setGoogleAnalyticsAccount } = googleSlice.actions;

export default googleSlice.reducer;
